import './index.css';

const LegacyIndicator = () => {
  return (
    <div className="legacy-indicator-root">
      <div className="legacy-indicator-top-connector"></div>
      <div className="legacy-indicator-container">
        {/** Circle */}
        <div className="legacy-indicator-circle">
          <span className="legacy-indicator-circle-text">CP</span>
          <div className="legacy-indicator-bottom-connector"></div>
        </div>
        {/** Connector  */}
        <div className="legacy-indicator-connector"></div>
        {/** Content */}
        <div className="legacy-indicator-content">
          <span className="legacy-indicator-content-title">
            Unknown Complex Params
          </span>
        </div>
      </div>
    </div>
  );
};

export default LegacyIndicator;
